import axios from 'axios'
var service = axios.create({
    baseURL: process.env.BASE_API,
    timeout: 50000
})
// 测试环境 　　　 https://test.tk.lanjiyin.com.cn
// 生产环境 　　　 https://tk.lanjiyin.com.cn
let api = ''
let userApi = ''
let payApi = ''
let imApi = ''
window.wxAppId = ''

if (location.hostname == 'm.lanjiyin.com.cn') {
    api = 'https://tk.lanjiyin.com.cn'
    // 预上线tk域名
    //api =  'https://devtk.lanjiyin.com.cn'

    userApi = "https://user.lanjiyin.com.cn"
    payApi = "https://pay.lanjiyin.com.cn"
    imApi = "https://im.lanjiyin.com.cn"
    window.wxAppId = "wx111e56c5ac493925"
} else if (location.hostname == 'mobile.lanjiyin.com.cn') {
    api = 'https://testtk.lanjiyin.com.cn'
    userApi = "https://testuser.lanjiyin.com.cn"
    payApi = "https://testpay.lanjiyin.com.cn"
    imApi = "https://testim.lanjiyin.com.cn"
    window.wxAppId = "wx111e56c5ac493925"
} else {
    if (true) {
        api = '/test'
        userApi = "/userApi"
        payApi = "/payApi"
        imApi = "/imApi"
    } else {
        api = '/api'
        userApi = "/userApi_api"
        payApi = "/payApi"
        imApi = "/imApi"
    }
}


//添加请求拦截器
service.interceptors.request.use(function (config) {
    let data = {
        app_id: localStorage.getItem('app_id'),
        app_type: localStorage.getItem('app_type'),
        user_id: getUser_id(),
        bundle_id: localStorage.getItem("bundle_id"),
        big_user_id: localStorage.getItem('big_user_id'),
        is_h5: 1,
        idfa: 111,
        token: getToken(),
        mobile_desc: "d57dc2200b5db4b6a3180bb01df2e11d"
    }

    config.headers["Content-Type"] = "multipart/form-data"
    for (let key of Object.keys(data)) {
        config.data.append(key, data[key]);
    }
    config.data.append('sign', getSign(config.data));
    if (/userApi/.test(config.url)) {
        config.url = userApi + config.url.replace(/userApi/, '');
    } else if (/payApi/.test(config.url)) {
        config.url = payApi + config.url.replace(/payApi/, '');
    } else if (/imApi/.test(config.url)) {
        config.url = imApi + config.url.replace(/imApi/, '');
    } else {
        config.url = api + config.url;
    }
    return config
}, function (error) {
    return Promise.reject(error)
})
//添加响应拦截器
service.interceptors.response.use(function (response) {
    if (response.headers.is_aes == 1) {
        response.data = JSON.parse(AesCbcDecrypt(response.data, 'lanjiyin20500423', 'lanjiyin20500423'))
    }
    return response.data
}, function (error) {
    console.log('err' + error)
    return Promise.reject(error)
}
)
export default service


// WEBPACK FOOTER //
// ./src/http/commentImg.js